import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const deleteAgentRecruitmentTask = createAsyncThunk("agentProfile/deleteAgentRecruitmentTask", async (data, thunkAPI) => {
  try {
    const resp = await axios.delete(`${process.env.REACT_APP_BASE_URL}api/recruitment/tasks/${data?.id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if(data.handleSuccessDelete){
      data.handleSuccessDelete()
    }
    return resp.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});